module.exports = __webpack_public_path__ + "static/media/podcast_cover.6f354b1c.jpg";